import React from 'react';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';

import UserAvatar from 'components/pure/utils/UserAvatar';
import AuthActions from 'actions/AuthActions';
import './UserDropdown.styl';
import {getMuiV4Theme} from 'utils/css/themeUtils';

const arrowDownStyle = {
  display: 'block',
  height: '30px',
  width: '30px',
};

const iconButtonStyle = {
  display: 'block',
  height: '30px',
  width: '30px',
  padding: '0',
};

/**
 * Dashboard top bar dropdown
 */
class UserDropdown extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      menuOptions: [
        {
          name: 'Get support',
          value: 'support',
        },
        {
          name: 'Logout',
          value: 'logout',
        },
      ],
      menuOpen: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleRequestChange = this.handleRequestChange.bind(this);
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  handleChange(event, value) {
    // eslint-disable-next-line
    switch (value) {
      case 'logout':
        AuthActions.logout({});
        break;
      case 'support':
        window.open('https://support.mediafly.com/hc/en-us', '_blank');
        break;
    }
  }

  handleTouchTap(event) {
    // open IconMenu
    this.setState({menuOpen: true});
  }

  handleRequestChange(open, reason) {
    // set menuOpen state when IconMenu is requested to open or close
    this.setState({menuOpen: open});
  }

  render() {
    const loggedUser = this.props.user;
    const displayName = loggedUser ? loggedUser.displayName : '';

    return (
      <div className="user-dropdown-component" onClick={this.handleTouchTap}>
        <UserAvatar user={loggedUser} enableTooltip={true} tooltipDirection="left" />
        <span className="user-name">{displayName}</span>
        <IconMenu
          iconButtonElement={
            <IconButton style={iconButtonStyle} iconStyle={arrowDownStyle}>
              <ArrowDown color={getMuiV4Theme().palette.primary.dark} />
            </IconButton>
          }
          anchorOrigin={{horizontal: 'right', vertical: 'top'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onChange={this.handleChange}
          onRequestChange={this.handleRequestChange}
          open={this.state.menuOpen}
          useLayerForClickAway={true}>
          {this.state.menuOptions.map((item, i) => (
            <MenuItem disabled={item.disabled} key={i} primaryText={item.name} value={item.value} />
          ))}
        </IconMenu>
      </div>
    );
  }
}

UserDropdown.displayName = 'UserDropdown';

export default UserDropdown;
